import { storage } from './storage';

export function resetStorage() {
    storage().clear();
}
